import { WorldsComponent } from './worlds/worlds.component';
import { PlansComponent } from './plans/plans.component';
import { HomeComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectsComponent } from './projects/projects.component';
import { ContactComponent } from './contact/contact.component';
import { PrePaymentComponent } from './pre-payment/pre-payment.component';
import { MarketplaceComponent } from './marketplace/marketplace.component';
import { ConferenciaCeremoniaComponent } from './conferencia-ceremonia/conferencia-ceremonia.component';
import { FeriaNegociosComponent } from './feria-negocios/feria-negocios.component';
import { CheckLoginGuard } from 'src/app/core/guards/auth/check-login.guard';
import { FeriaEscolarComponent } from './feria-escolar/feria-escolar.component';
import { YincanaComponent } from '../main/yincana-ar/yincana-ar.component';

const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [CheckLoginGuard] },
  {
    path: 'plans',
    component: PlansComponent,
    // canActivate: [CheckLoginGuard],
  },
  {
    path: 'projects',
    component: ProjectsComponent,
    // canActivate: [CheckLoginGuard],
  },
  {
    path: 'contact',
    component: ContactComponent,
    // canActivate: [CheckLoginGuard],
  },
  {
    path: 'pre-payment/:precio/:return_url',
    component: PrePaymentComponent,
    // canActivate: [CheckLoginGuard],
  },
  {
    path: 'market',
    component: MarketplaceComponent,
    // canActivate: [CheckLoginGuard],
  },
  {
    path: 'confe-ceremonia',
    component: ConferenciaCeremoniaComponent,
    // canActivate: [CheckLoginGuard],
  },
  {
    path: 'feria-negocios',
    component: FeriaNegociosComponent,
    // canActivate: [CheckLoginGuard],
  },
  {
    path: 'feria-escolar',
    component: FeriaEscolarComponent,
    // canActivate: [CheckLoginGuard],
  },
  {
    path: 'yincana-ar',
    component: YincanaComponent,
    // canActivate: [CheckLoginGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PreAuthRoutingModule {}
